import { useTranslation } from 'react-i18next';
import BenchmarkRange from '../BenchmarkRange';

import { BenchMarkScoreMetaData } from '../../../../shared/types/widget';
import useFilters from '../../../../utilities/hooks/useFilters';
import { getLabelAndColor } from '../../../../utilities/common/utils';
import { SelectedBenchmark } from '../../../../shared/constants/filter/filter';

import caretDown from '../../../../assets/icons/General/caret-down-gray.svg';

interface BenchmarkScoreBarProps {
  scoreBarData: BenchMarkScoreMetaData;
}

function BenchmarkScoreBar({ scoreBarData }: BenchmarkScoreBarProps) {
  const { t } = useTranslation();
  const { benchmarkType } = useFilters();
  const backgroundColor = getLabelAndColor(
    scoreBarData?.data?.value,
    scoreBarData?.meta.scoreRanges,
  );

  return (
    <div className="intl-widget-ignore-element relative">
      <div
        className="flex justify-end"
        style={{ width: `${scoreBarData?.data?.value ?? 0}%` }}
      >
        <div className="relative w-full">
          <div className="bg-grey-900 absolute -top-8 right-0 z-9 w-max translate-x-1/2 rounded-lg px-2 py-1 text-sm font-medium text-white">
            {t('YOUR_SCORE')}: {Math.round(scoreBarData?.data?.value)}
            <div
              style={{
                width: '0.75rem',
                height: '0.75rem',
                background: 'var(--color-grey-900)',
                transform: 'translateX(-50%) rotate(45deg)',
                position: 'absolute',
                top: '18px',
                left: '50%',
                transformOrigin: 'center',
                zIndex: -1,
              }}
            ></div>
            <div className="border-black-900 absolute top-[29px] left-1/2 h-[23px] w-[1px] -translate-x-1/2 border" />
          </div>
        </div>
      </div>
      <div className="intl-widget-ignore-element bg-taupe-400 absolute h-5 w-full rounded-sm" />
      <div
        className="intl-widget-ignore-element absolute h-5 rounded-sm"
        style={{
          width: `${scoreBarData?.data?.value}%`,
          backgroundColor: backgroundColor?.color,
        }}
      />

      <div
        className="flex justify-end"
        style={{ width: `${Math.round(scoreBarData?.data?.average)}%` }}
      >
        <div className="relative mt-11 w-full">
          <div className="absolute -top-[21px] right-0 translate-x-1/2">
            <div className="border-grey-300 absolute -top-[22px] left-1/2 h-[22px] w-[1px] -translate-x-1/2 border border-dashed" />
            <img
              src={caretDown}
              className="relative -top-1 mx-auto"
              alt="Caret down"
            />

            <p className="text-grey-600 absolute top-4 left-1/2 -translate-x-1/2 text-sm font-medium whitespace-nowrap">
              {benchmarkType == SelectedBenchmark.GLOBAL
                ? t('GLOBAL')
                : t('INDUSTRY')}{' '}
              {t('AVERAGE')}: {Math.round(scoreBarData?.data?.average)}
            </p>
          </div>
        </div>
      </div>

      <BenchmarkRange
        meta={scoreBarData?.meta}
        className="mt-[2.75rem] flex-col gap-y-[10px] lg:flex-row lg:gap-y-[18px]"
      />
    </div>
  );
}

export default BenchmarkScoreBar;
